export * from 'react-router-dom';
export * from 'history';
import { withRouter as _withRouter } from 'react-router-dom';
export const withRouter = _withRouter;